module.exports = __webpack_public_path__ + "img/3f0d3836fcb8572d0f0992575b985e1a.857d82ef.webp";